/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500,
} from "../../types/individualPaymentEditorsController/PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid.ts";

function getPutApiV1IndividualpaymentFinancialPeopleFinancialpersonidUrl(
  financialPersonId: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams["financialPersonId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}` as const,
  };
  return res;
}

/**
 * @description Atualiza o plano com recálculo de parcelas quando muda valor/nº de parcelas/pontualidade/bolsa ou descontos, ajuste do dia de vencimento nas parcelas em aberto, aproveitamento de inscrição (quita matrícula e move p/ ApprovalPending) e fluxos de bolsa (geração forçada e desconto de bolsa). Migrado do legado IndividualPayment/FinancialPersonEdit POST. **(Requer Authorization para autenticação)**
 * @summary Atualiza o plano financeiro individual (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId}
 */
export async function putApiV1IndividualpaymentFinancialPeopleFinancialpersonid(
  financialPersonId: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams["financialPersonId"],
  data?: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500
    >,
    PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1IndividualpaymentFinancialPeopleFinancialpersonidUrl(
      financialPersonId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
